import React, { useEffect, useState } from 'react'
import ReactDOM from "react-dom";
import Header from '../components/Header'
import LeftComponent from '../components/LeftComponent'
import { useDispatch, useSelector } from 'react-redux'
//import moment from 'moment';
import { listColleges, listTotalColleges } from '../actions/collegeActions';
import Country from '../components/Country';
import { universitySearchJson } from '../models/universitySearchModel';
import { COLLEGE_LIST_RESET } from '../constants/collegeConstants';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';

export default function UniversityScreen() {
  const dispatch = useDispatch()
  const [universityJson, setuniversityJson] = useState(universitySearchJson)
  const [searchtxt, setsearchtxt] = useState("")

  const collegeList = useSelector((state) => state.collegeList);
  const { loading, colleges, error } = collegeList;

  const collegeListTotal = useSelector((state) => state.collegeListTotal);
  const { loading: loadingTotal, collegeTotal, error: errorTotal } = collegeListTotal;

  const handleJson = (e) => {
    setuniversityJson({ ...universityJson, [e.target.name]: e.target.value })
  }

  const getUniversities = (e) => {
    e.preventDefault();
    dispatch(listColleges(universityJson));
    dispatch(listTotalColleges(universityJson));
  }

  const getUniversities1 = (e) => {
    //console.log(e.selected + 1)
    setuniversityJson({ ...universityJson, "pageno": (e.selected + 1) })
    dispatch(listColleges(universityJson));
  }

  const searchUniversity = (e) => {
    e.preventDefault();
    setuniversityJson({ ...universityJson, "pageno": 1 })
    getUniversities(e);
  }

  const ResetUniversities = (e) => {
    e.preventDefault();
    setuniversityJson(universitySearchJson)
    dispatch({ type: COLLEGE_LIST_RESET })
  }

  useEffect(() => {
    if (error == undefined) {
      if (colleges == undefined || colleges.length == 0) {
        dispatch(listColleges(universityJson));
        dispatch(listTotalColleges(universityJson));
      } else {

      }
    }
  }, [dispatch, colleges])

  return (
    <>
      <Header pageName="College" />
      <LeftComponent>
        <div className="content-body">
          <div className='container-fluid'>

            <div className="heading-title border-none">
              <div className='row'>
                <div className="col-md-12">
                  <div className="home-title float-left">
                  </div>
                  <div className="home-table-search float-right d-flex">
                    <div class="input-group search-contacts" bis_skin_checked="1">
                      <form onSubmit={searchUniversity} class="ng-pristine ng-valid">
                        <input type="text" id="searchUni" class="form-control ng-pristine ng-valid ng-empty ng-touched" placeholder="Search University" name="searchtxt" value={universityJson.searchtxt} onChange={e => handleJson(e)} /><i class="fa fa-search" aria-hidden="true" onClick={searchUniversity}></i>
                      </form>
                    </div>
                    <div class="right-click Create-btn" bis_skin_checked="1">
                      <Link to="/university/create" target="_blank" className="btn create-contact" >Create University</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="inner-body">
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="filter-in-mob-view text-right">
                    <input type="text" name="search" placeholder="Search Contacts..." />
                    <i className="fas fa-filter mob-nav-open"></i>
                  </div>
                  {/* <!-- /filter-in-mob-view --> */}

                  <div className="add-filter">
                    <div className="filter-title  filter-title-mob">
                      <h5>Filter Colleges</h5>
                      <button className="mob-nav-open">☰</button>
                    </div>
                    <div className="filter-body filter-body-mob custom-scroll-right pt-0">
                      <div className="sticky pt-2">
                        {/* <h6><strong> My Primary Contacts</strong></h6>
                        <p>showing 751 Contats</p>

                        <h6><strong>My Secondary Contacts</strong></h6>
                        <p>showing 851 Contats</p>

                        <h6><strong> All Contacts</strong></h6>*/}
                        {
                          loadingTotal ? (
                            <>
                              <p>loading...</p>
                            </>
                          ) : (
                            collegeTotal ? (
                              <p>Showing {collegeTotal} Colleges</p>
                            ) : (
                              <>
                                {
                                  collegeTotal == 0 ? (
                                    <p>No Record Exist!</p>
                                  ) : (
                                    <p>{errorTotal}</p>
                                  )
                                }
                              </>

                            )
                          )
                        }

                        {/* <h6><strong> All Filter</strong></h6> */}
                        <button type="submit" className="btn btn-sm btn-deep-orange" onClick={e => getUniversities(e)}> Apply Filters</button>
                        <br />
                        <button type="submit" className="btn btn-sm btn-deep-orange" onClick={e => ResetUniversities(e)}> Reset Filters</button>
                      </div>

                      <ul className="modify-filter-title">
                        {/* <li className="chose">Invoice</li>
                        <li>
                          <select className="form-control">
                            <option value="">--Select--</option>
                            <option value="">lorem ipsum</option>
                          </select>
                        </li>*/}
                        <li className="chose">Country</li>
                        <li>
                          <select className="form-control" name="countryid" value={universityJson.countryid} onChange={e => { handleJson(e) }}>
                            <option value="">--Select--</option>
                            <Country />
                          </select>
                        </li>
                        <li className="chose">Partnership</li>
                        <li>
                          <select className="form-control" name="partnership" value={universityJson.partnership} onChange={e => { handleJson(e) }}>
                            <option value="">--Select--</option>
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-lg-10">
                  <div className="coctacts-table">
                    <div className="table-responsive custom-scroll-right-bottum">
                      <table className="table table-condensed ">
                        <thead className="t-head-th-bg">
                          <tr>
                            {/* <th className="t-head-fixed"><input type="checkbox" value="check" /></th> */}
                            <th className="t-head-fixed">University Id</th>
                            <th className="t-head-fixed">University Name</th>
                            <th className="t-head-fixed">Country</th>
                            <th className="t-head-fixed">World Ranking</th>
                            <th className="t-head-fixed">Country Ranking</th>
                            <th className="t-head-fixed">University Address</th>
                            <th className="t-head-fixed">Contact Person</th>
                            <th className="t-head-fixed">Contact Person <br />Number</th>
                            <th className="t-head-fixed">Contact Person <br />Email</th>
                          </tr>
                        </thead>
                        <tbody className="table-bordered">
                          {
                            loading ? (
                              <tr>
                                <td colSpan="11">Loading...</td>
                              </tr>
                            ) : (
                              <>
                                {
                                  colleges ? (
                                    (colleges.length > 0) ? (
                                      colleges.map((invo) => {
                                        var editLink = `/university/edit/${invo.University_Id}`
                                        return (
                                          <tr key={invo.Id}>
                                            <td>{invo.University_Id}</td>
                                            <td>{invo.University_Name} - <Link to={editLink} className="linkBlue" target="_blank">Edit</Link></td>
                                            <td>{invo.Country}</td>
                                            <td>{invo.World_Ranking}</td>
                                            <td>{invo.Country_Ranking}</td>
                                            <td>{invo.University_Address}</td>
                                            <td>{invo.Contact_Person}</td>
                                            <td>{invo.Contact_Number}</td>
                                            <td>{invo.Contact_Email}</td>
                                          </tr>
                                        )
                                      })
                                    ) : (
                                      <tr>
                                        <td colSpan={10}>{error}</td>
                                      </tr>
                                    )
                                  ) : (
                                    <>
                                      <tr>
                                        <td colSpan={10}>{error}</td>
                                      </tr>
                                    </>
                                  )
                                }
                              </>

                            )
                          }

                        </tbody>
                      </table>
                    </div>

                    <div className="table-page-details">
                      <div className="row">

                        <div className="col-md-12">

                          <ReactPaginate
                            className="pagination justify-content-center"
                            activeClassName="activeClass"
                            breakLabel="..."
                            nextLabel="Next"
                            nextClassName="nextClass"
                            previousClassName="previousClass"
                            pageClassName="page-item"
                            onPageChange={getUniversities1}
                            pageRangeDisplayed={5}
                            pageCount={collegeTotal / 25}
                            previousLabel="Previous"
                            renderOnZeroPageCount={null}
                            pageLinkClassName="page-link"
                          />
                          {/* <ReactPaginate
                            // itemClass="page-item"
                            innerClass="pagination justify-content-center"
                            activePage={universitySearchJson.pageno}
                            // activeClass="activeClass"
                            itemsCountPerPage={universitySearchJson.pagesize}
                            totalItemsCount={collegeTotal}
                            pageRangeDisplayed={7}
                            onChange={getUniversities1}
                            linkClass="page-link"
                          /> */}

                          {/* <div className="page-number">
                            <ul className="pagination justify-content-center">
                              <li className="page-item">
                                <a className="page-link" href="#" tabindex="-1">Previous</a>
                              </li>
                              <li className="page-item">
                                <a className="page-link" href="#">1</a>
                              </li>
                              <li className="page-item">
                                <a className="page-link" href="#">2</a>
                              </li>
                              <li className="page-item">
                                <a className="page-link" href="#">3</a>
                              </li>
                              <li className="page-item">
                                <a className="page-link" href="#">Next</a>
                              </li>
                            </ul>
                          </div> */}
                        </div>
                        {/* <div className="col-md-3 text-center">
                          <div className="page-counter">
                            <label>
                              <select>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select> of <span>70</span> records</label>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LeftComponent>
    </>
  )
}

